// 仅解释服务端 executionStatus，不从标题猜测结果。新状态先扩展协议校验，再补充此表。
// ACCEPTED 仅表示指令已发送，UNKNOWN 表示无法确认结果，均不得展示为成功或引导重复控制。
export const TASK_STATES = Object.freeze({
  NOT_STARTED: { label: '正在处理', tone: 'active' },
  DISPATCHING: { label: '正在处理', tone: 'active' },
  ACCEPTED: { label: '指令已发送', tone: 'active', detail: '尚未确认设备执行结果。' },
  SUCCEEDED: { label: '执行成功', tone: 'success' },
  FAILED: { label: '执行失败', tone: 'error' },
  UNKNOWN: { label: '结果待确认', tone: 'warning', detail: '请先核对设备状态，避免重复执行。' },
  CANCELLED: { label: '已取消', tone: 'neutral' },
  EXPIRED: { label: '已过期', tone: 'neutral' }
})

// Legacy phase is intentionally ignored; internal execution states retain their meaning.
export function taskState(card) {
  const status = { QUEUED: 'NOT_STARTED', EXECUTING: 'DISPATCHING' }[card.executionStatus] || card.executionStatus
  return TASK_STATES[status] || TASK_STATES.UNKNOWN
}
